import styled from 'styled-components';
import { PopoverArrowMixin } from '../../mixins/components/PopoverArrowMixin';

/**
 * A helper for the `Popover` component.
 *
 * @since 7.0.0
 */
var PopoverArrow = /*#__PURE__*/styled.div.withConfig({
  displayName: "PopoverArrow",
  componentId: "c11n-8-107-0__sc-ji6mam-0"
})(["", ""], PopoverArrowMixin);
PopoverArrow.displayName = 'PopoverArrow';

/** @component */
export { PopoverArrow };